export type AssetTimeZoneMode = "local" | "asset" | "UTC";

export interface AssetTimeZoneContext {
  assetTimeZone: string | null;
  timeZone: string;
  timeZoneMode: AssetTimeZoneMode;
}

const assetTimeZoneStore = new Map<string, AssetTimeZoneContext>();

export const setAssetTimeZoneContext = (
  assetId: string | undefined,
  context: AssetTimeZoneContext
) => {
  if (!assetId) {
    return;
  }
  assetTimeZoneStore.set(assetId, context);
};

export const getAssetTimeZoneContext = (
  assetId: string | undefined
): AssetTimeZoneContext | undefined => {
  if (!assetId) {
    return undefined;
  }
  return assetTimeZoneStore.get(assetId);
};

export const clearAssetTimeZoneContext = (assetId: string | undefined) => {
  if (!assetId) {
    return;
  }
  assetTimeZoneStore.delete(assetId);
};
